import { render } from "./Alerts.vue?vue&type=template&id=78128c0a&scoped=true"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"

import "./Alerts.vue?vue&type=style&index=0&id=78128c0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-78128c0a"

export default script